<script setup lang="ts">
definePageMeta({ layout: 'default' })

useHead({
  title: 'App',
  meta: [
    {
      name: 'description',
      content: 'Die Bahn-Vorhersage App für Android und iOS.'
    }
  ]
})

import getItOnFDroid from '~/assets/img/get-it-on-f-droid.svg'
import getItOnGPlay from '~/assets/img/google-play-badge.svg'
import getItOnIOS from '~/assets/img/get-it-on-ios.svg'
</script>

<template>
  <div class="row g-2 justify-content-center my-5">
    <div class="col-xxl-6 col-xl-7 col-lg-8 col-md-11 hyphenate">
      <h1>Bahn-Vorhersage App</h1>
      <p>
        Die Bahn-Vorhersage App ist als kleiner Begleiter für die Nutzung auf dem Handy optimiert.
        Zudem entlastet sie die Bahn-Vorhersage Server, da ein Teil der Logik von der App selbst
        übernommen werden kann. Somit ist die App, wenn viele Menschen die Bahn-Vorhersage benutzen,
        zuverlässiger als die Webseite.
      </p>
      <div class="d-flex gap-3 flex-wrap justify-content-center my-3">
        <a
          href="https://f-droid.org/packages/de.bahnvorhersage.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img :src="getItOnFDroid" alt="Get it on F-Droid" height="60" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=de.bahnvorhersage.app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="getItOnGPlay"
            style="filter: brightness(50%)"
            alt="Get it on Google Play"
            height="60"
          />
        </a>
        <a
          href="https://apps.apple.com/de/app/bahn-vorhersage/id6757105454"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img :src="getItOnIOS" alt="Download on App Store" height="60" />
        </a>
      </div>
      <p>
        Die Version von F-Droid wird empfohlen, da diese besser getestet ist.
        <b>Vielen Dank an Gregor Walter fürs Veröffentlichen und Maintainen der iOS App.</b>
      </p>
      <div class="card text-bg-warning p-2">
        <div class="card-body">
          <div class="mb-3" id="my-banner"></div>
          <Script
            src="https://keepandroidopen.org/banner.js?lang=de&size=mini&id=my-banner"
          ></Script>
          <p>
            Google Play blockiert die App seit dem 1. Oktober 2026, weil ich diese auch über F-Droid
            verteile und ich für F-Droid nicht nachgewiesen habe, dass ich der Entwickler bin. Für
            weitere Infos dient das unauffällige rote Banner.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
